import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'letter-l-small', 'LetterLSmall', [["path",{"d":"M10 8v8h4"}]]);